import { render, staticRenderFns } from "./login-box.vue?vue&type=template&id=51d48252"
import script from "./login-box.vue?vue&type=script&lang=js"
export * from "./login-box.vue?vue&type=script&lang=js"
import style0 from "./login-box.vue?vue&type=style&index=0&id=51d48252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports